const TrashIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.133 5.23047C11.133 5.23047 10.771 9.72047 10.561 11.6118C10.461 12.5151 9.90303 13.0445 8.98903 13.0611C7.2497 13.0925 5.50836 13.0945 3.7697 13.0578C2.89036 13.0398 2.3417 12.5038 2.2437 11.6165C2.03236 9.70847 1.67236 5.23047 1.67236 5.23047"
        stroke={"#0C172C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.0553 3.07552L0.75 3.07552"
        stroke={"#0C172C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9.87689 3.076C9.35356 3.076 8.90289 2.706 8.80022 2.19333L8.63822 1.38267C8.53822 1.00867 8.19956 0.75 7.81356 0.75L4.99156 0.75C4.60556 0.75 4.26689 1.00867 4.16689 1.38267L4.00489 2.19333C3.90222 2.706 3.45156 3.076 2.92822 3.076"
        stroke={"#0C172C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default TrashIcon;
